<template>
  <div
    id="link-right"
    :class="beyond?'beyond':''"
  >
    <!-- 链接信息 -->
    <div
      ref="attrWrapper"
      class="attr-wrapper"
      :style="{height:(curData.delivery_ad && isAdv)?'calc(100% - 224px)':'auto'}"
    >
      <div class="title">
        <svg class="attr-img">
          <use :xlink:href="curData.fileType" />
        </svg><!--
                --><co-tips
:content="curData.name"
position="bottom"
>
                    <div class="attr-title">
{{ curData.fakeName }}
</div>
                </co-tips><!--
                --><span
v-show="curData.isVirus"
class="virus"
>{{ $t('病毒') }}</span>
      </div>
      <div class="attr-content">
        <div class="content-key">
          {{ $t('过期时间') }}:
        </div>
        <div class="content-val">
          {{ curData.expiration }}
        </div>
        <div class="content-key">
          {{ $t('大小') }}:
        </div>
        <div class="content-val">
          {{ curData.size }}
        </div>
        <div class="content-key">
          {{ $t('创建者') }}:
        </div>
        <co-tips
          :content="curData.delivery_creator"
          position="bottom"
        >
          <div class="content-val ellipsis">
            {{ curData.delivery_creator }}
          </div>
        </co-tips>
        <div class="content-key">
          {{ $t('创建时间') }}:
        </div>
        <div class="content-val">
          {{ curData.delivery_mtime }}
        </div>
        <div
          v-show="curData.desc_area"
          class="msg-wrapper"
        >
          <div class="content-key">
            {{ $t('链接说明') }}:
          </div>
          <div class="content-val">
            {{ curData.desc_area }}
          </div>
        </div>
      </div>
    </div>
    <!-- 广告位老版本 -->
    <div
      v-show="curData.delivery_ad && isAdv && type == 0"
      class="adv-wrapper"
    >
      <!-- 广告图位置，旧版本的src -->
      <img
        :src="adLogoSrc"
        alt=""
      >
      <div
        class="common-close wh"
        @click="closeAdv"
      >
        <svg class="close-svg">
          <use xlink:href="#w-close" />
        </svg>
      </div>
      <span class="button-title cp">
        <a href="/user/reg">{{ $t('免费试用') }}</a>
      </span>
      <span class="adv-title">{{ $t('联想智能协作平台') }}</span>
    </div>
    <!-- 预热版本 -->
    <div
      v-show="curData.delivery_ad && isAdv && type == 1"
      class="adv-wrapper"
    >
      <!-- 广告图位置，旧版本的src -->
      <img
        :src="adLogoSrc"
        alt=""
        @click="toUse"
      >
      <div
        class="common-close bh"
        @click="closeAdv"
      >
        <svg class="close-svg">
          <use xlink:href="#b-close" />
        </svg>
      </div>
    </div>
    <!-- 升级版本 -->
    <div
      v-show="curData.delivery_ad && isAdv && type == 2"
      class="adv-wrapper"
    >
      <img
        :src="adLogoSrc"
        alt=""
      >
      <div
        class="common-close bh"
        @click="closeAdv"
      >
        <svg class="close-svg">
          <use xlink:href="#b-close" />
        </svg>
      </div>
      <span class="button-title cp new-title">
        <a @click="toUse">{{ $t('试用全新品牌') }}</a>
      </span>
    </div>


    <!-- 版权 -->
    <div
      v-show="!(curData.delivery_ad && isAdv)"
      class="copyright"
    >
      <span
        :style="{color:copyrightColor}"
        v-text="copyright"
      />
    </div>
  </div>
</template>
<script>
import {
  formatDate, resolvePath, typeIcon, getLanguage,
} from 'js/util/util.js'
import coTips from 'components/common/tips/index.vue'
import { FILEHANDER } from 'js/mixin/fileType.js'

export default {
  components: {
    coTips,
  },
  mixins: [FILEHANDER], // 引用了getFolderType方法
  props: {
    data: {
      type: Object,
      default() {
        return {
        }
      },
    },
  },
  data() {
    return {
      type: 0, // 0 旧版本 1 预热 2. 升级
      isFolder: false, // 是否为文件夹外链内的文件
      copyright: '©Filez', // 版权文字
      copyrightColor: '#929CA9', // 版权文字颜色
      isAdv: true,
      closeIcon: '#close', // 控制关闭按钮图标
      beyond: false, // wrapper是否高于窗口
    }
  },
  computed: {
    /**
         * 获取图片src
         */
    adLogoSrc() {
      let defaultSrc = require('./image/adv.png')
      const pre_en = require('./image/pre_en.png')
      const pre_zh = require('./image/pre_zh.png')
      const new_en = require('./image/new_en.png')
      const new_zh = require('./image/new_zh.png')
      const lan = getLanguage()
      const lanArr = ['zh', 'tw']
      // 0327 与交互确认后，中文繁体 显示中文，其余的显示英文
      let cd = this.$store.state.lenovoData.countdown || {}
      cd = cd.countdown
      // 如果为 < 1 则为倒计时，大于15时为旧版本的页面
      if (lanArr.indexOf(lan) != -1) {
        if (cd < 1) {
          this.type = 2
          defaultSrc = new_zh
        } else if (cd < 16 && cd > 0) {
          this.type = 1
          defaultSrc = pre_zh
        } else {
          this.type = 0
        }
        return defaultSrc
      }
      if (cd < 1) {
        this.type = 2
        defaultSrc = new_en
      } else if (cd < 16 && cd > 0) {
        this.type = 1
        defaultSrc = pre_en
      } else {
        this.type = 0
      }
      return defaultSrc
    },
    curData() {
      return {
        name: this.data.path == '/' ? resolvePath(this.data.content[0].path).name : resolvePath(this.data.path).name,
        fakeName: this.data.path == '/' ? this.getFakeName(resolvePath(this.data.content[0].path).name) : this.getFakeName(resolvePath(this.data.path).name),
        size: this.curDataSize,
        delivery_creator: this.data.delivery_creator,
        delivery_mtime: formatDate(this.data.delivery_mtime, 'yyyy-MM-dd hh:mm'),
        expiration: this.data.expiration != -1 ? this.getExpiration(new Date(), formatDate(this.data.expiration, 'yyyy-MM-dd hh:mm')) : this.$t('未设置有效期'),
        desc_area: this.data.delivery_desc,
        fileType: this.data.is_dir ? `#${typeIcon(this.getFolderType(resolvePath(this.data.path).type))}` : `#${typeIcon(resolvePath(this.data.path).type)}`, // 判断文件or文件夹
        delivery_ad: this.data.delivery_ad,
        isVirus: this.data.is_dir ? false : this.data.isvirus,
      }
    },
    curDataSize() {
      if (this.data.is_dir) {
        return this.$t('共{n}项', { n: this.data.total_size })
      }
      return this.data.size ? this.data.size : '--'
    },
  },
  watch: {
    curData: {
      handler(n) {
        if (!n.delivery_ad) {
          const vm = this
          this.$nextTick(() => {
            vm.checkBeyondWinH()
          })
          window.addEventListener('resize', vm.checkBeyondWinH)
        }
      },
      deep: true,
    },
  },
  methods: {
    toUse() {
      location.href = '/user/reg'
    },
    /**
         * 返回...name
         */
    getFakeName(name) {
      if (!name) {
        return ''
      }
      if (String(name).length >= 34) {
        return `${String(name).substring(0, 34)}...`
      }
      return String(name)
    },
    /**
         * 计算时间差
         * mdate当前时间    edate过期时间
         */
    getExpiration(mdate, edate) {
      // 相差多少分钟
      const exDate = Math.floor(Math.abs(Date.parse(this.delimiterConvert(String(edate))) - Date.parse(this.delimiterConvert(String(mdate)))) / (60 * 1000))
      if (exDate <= 1440) { // 小于等于1天
        const hour = Math.floor(exDate / 60) == 0 ? '' : (Math.floor(exDate / 60) == 1 ? this.$t('1小时') : Math.floor(exDate / 60) + this.$t('小时'))
        const min = (exDate % 60) == 0 ? '' : ((exDate % 60) == 1 ? this.$t('1分钟') : (exDate % 60) + this.$t('分钟'))
        return hour + min + this.$t('后')
      } if (exDate > 1440 && exDate < 43200) { // 大于一天 小于 一个月
        return Math.floor(exDate / (60 * 24)) == 1 ? this.$t('1天') + this.$t('后') : (Math.floor(exDate / (60 * 24)) + this.$t('天') + this.$t('后'))
      }
      return edate
    },
    /**
         * 格式化时间  兼容ie
         */
    delimiterConvert(val) {
      return val.replace('-', '/').replace('-', '/')
    },
    /** 关闭广告 */
    closeAdv() {
      const vm = this
      this.isAdv = !this.isAdv
      this.$nextTick(() => {
        vm.checkBeyondWinH()
      })
      window.addEventListener('resize', vm.checkBeyondWinH)
    },
    /**
         * 检查wrapper的高度是否超出body
         */
    checkBeyondWinH() {
      const vm = this
      const HH = 50 // header height
      if (this.curData.delivery_ad && this.isAdv) return
      if (!vm.$refs.attrWrapper) return
      if (vm.$refs.attrWrapper.offsetHeight > (document.body.clientHeight - HH)) {
        vm.beyond = true
      } else {
        vm.beyond = false
      }
    },

  },
}
</script>
<style lang="less" scoped>
@import '~less/dialog.less';

#link-right{
  height: 100%;
  width: 288px;
  box-sizing: border-box;
  position: relative;
  border-left: 1px solid #e2e6ec;
}
.ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
//文件名
.title{
  display: block;
  width: 240px;
  position: relative;
  //不需要...的样式
  .attr-title{
    display: inline-block;
    line-height: 22px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #282E3D;
    max-width: 212px;
    vertical-align: top;
    word-break: break-all;
  }
  .attr-img{
    width: 22px;
    height: 22px;
    margin-right: 6px;
    position: relative;
    left: -1px;
  }
  .virus {
    font-size: 12px;
    color: #FF5554;
    border: 1px solid #FF5554;
    border-radius: 2px;
    padding: 0 2px;
    margin-left: 8px;
    vertical-align: 6px;
  }
}
.attr-wrapper{
  padding: 32px 24px 0 24px;
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
}
//文件信息
.attr-content{
  width: 240px;
  box-sizing: border-box;
  margin-top: 30px;
  .content-key{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #67707C;
    line-height: 20px;
    margin-bottom: 4px;
  }
  .content-val{
    display: inline-block;
    max-width: 240px;
    box-sizing: border-box;
    word-break: break-all;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #1B2733;
    line-height: 20px;
    margin-bottom: 20px;
    word-break: break-all;
  }
}
//链接说明
.msg-wrapper .content-val{
  line-height: 18px;
  margin-bottom: 0;
}
//广告位
.adv-wrapper{
  z-index: 10;
  width: 240px;
  height: 210px;
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 24px;
  img{
    width: 240px;
    height: 210px;
  }
  .common-close{
    position: absolute;
    right: 6px;
    top: 6px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
    border-radius: 50%;
    .close-svg{
      vertical-align: middle;
      width:12px;
      height: 12px;
    }
  }
  .wh{
    &:hover{
      background: rgba(255,255,255,0.2);
    }
  }
  .bh{
    &:hover{
      background: rgba(0,0,0,0.2);
    }
  }
  .adv-title{
    position: absolute;
    text-align: center;
    color: #fff;
    top: 51px;
    left: 0;
    font-size: 22px;
    right: 0;
    margin: auto;
  }
  .button-title {
    box-sizing: border-box;
    text-align: center;
    display: block;
    width: 96px;
    height: 34px;
    line-height: 34px;
    background: transparent;
    border: 1px solid #fff;
    border-radius: 2px;
    position: absolute;
    top: 110px;
    left: 0;
    right: 0;
    margin: 0 auto;
    &:hover{
      background: rgba(255,255,255,0.20);
    }
  }

  .button-title a {
    color: #fff;
    font-size: 16px;
    text-align: center;
    &:hover{
      text-decoration: none;
    }
  }
  .new-title {
    background: #0A64FA;
    border: 1px solid #0A64FA;
    width: 140px;
    top: 130px;
    &:hover {
      border: 1px solid #3b83fb;
      background-color: #3b83fb;
    }
  }
}
//版权
.copyright{
  position: absolute;
  width: 83px;
  text-align: center;
  left: 0;
  right: 0;
  bottom: 18px;
  margin: 0 auto;
  font-size: 12px;
}
.beyond{
  overflow: auto;
  .copyright{
    position: static;
    margin-bottom: 18px;
  }
}

</style>
